import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import axios from 'axios';
import styles from './checkout.module.css'
import { CURRENCY_SIGNS, numberFormatter } from '../hooks/HelperFunctions';
import { useSelector } from 'react-redux';

const StripeCheckout = (props) => {
    const {
      courses,
      cartItems,
      paymentData, 
      paymentInfo,
      clientSecret,
      setPaymentInfo,
      totalPriceToShow,
      setOpenPaymentDrawer,
    } = props
    
    const baseUrl = process.env.NEXT_PUBLIC_PROJECT_ENV === 'prod' ? process.env.NEXT_PUBLIC_API_URL_PROD : process.env.NEXT_PUBLIC_API_URL_DEV;
    const stripe = useStripe();
    const elements = useElements();

    const activeCurrency = useSelector(
      (state) => state.currency.activeCurrency
    );

    const [message, setMessage] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    // const [clientSecret, setClientSecret] = useState('');
    // const [paymentInfo, setPaymentInfo] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsProcessing(true);

        localStorage.removeItem("coursesRefferedByOrg")
        localStorage.removeItem("tracksRefferedByOrg")
        localStorage.removeItem("organizationsReferred")

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
            // Make sure to change this to your payment completion page
            return_url: `${window.location.origin}/payment-status?success=true&payment-id=${paymentInfo?.paymentData?.paymentId}`,
            },
        });

        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occured.");
        }
        setIsProcessing(false);
    };

    const getTheCorrectCurrencySign = () => {
      return CURRENCY_SIGNS[activeCurrency] ?? "$";
    };

    return (

<form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <div className={styles.CheckOutFooter}>
        <button
          className={styles.PayNowButton}
          disabled={isProcessing || !stripe || !elements}
          id="submit"
        >
          <span id="button-text">
            {isProcessing ? "Processing ... " : `Pay ${getTheCorrectCurrencySign()}${numberFormatter(totalPriceToShow)}`}
            {/* {isProcessing ? "Processing ... " : `Pay $${numberFormatter(totalPriceToShow/100)}`} */}
          </span>
        </button>
      </div>
        {/* Show any error or success messages */}
      {message && <div id="payment-message" className={styles.CardNumberError}>{message}</div>}

      
    </form>
    );
};

export default StripeCheckout;